import { CommonConstant, Protocols } from "utility";
import { marketplaceContractAbi } from "contract/marketplace";
import { RentalTypes } from "./constant";
import { UserService } from "./services/user";
import { AbiItem } from "web3-utils";

export class ContractUtility {
  static config: any = {};

  static getVersionParam = () => {
    let url = new URL(window.location.href);
    let version = url.searchParams.get("v");
    return version;
  };
  static version = ContractUtility.getVersionParam() || "v";

  static setConfig = (config) => {
    ContractUtility.config = { ...config };
  };

  static getContractAddress = (networkName) => {
    switch (networkName) {
      case "main":
        return ContractUtility.config.ethereum;
      case "private":
        return ContractUtility.config.polygon;
      case "rinkeby":
        return ContractUtility.config.rinkeby;
      case "ropsten":
        return ContractUtility.config.ropsten;
      default:
        return {};
    }
  };

  static getPaymentMethods = (protocol) => {
    switch (protocol) {
      case Protocols.ethereum.name:
      case Protocols.bsc.name:
      case Protocols.polygon.name:
        return ContractUtility.config[protocol].payment_methods;
      default:
        return [];
    }
  };

  static getMoralisKeys = (networkName) => {
    switch (networkName) {
      case "main":
      case "private":
        return {
          serverUrl: "https://im5edb4xnfxc.usemoralis.com:2053/server",
          appId: "O8QrWqOWXUypTAMKhNd5nj1qVQymXfu71edNCKgL",
          chain: networkName == "main" ? "ethereum" : "polygon",
        };
      case "rinkeby":
        return {
          serverUrl: "https://kodzkxzmdrce.usemoralis.com:2053/server",
          appId: "AZbnPhH6KAFCIDTOAr7YWTr4CdLikf9ujqgwKHis",
          chain: "rinkeby",
        };
      default:
        return {};
    }
  };

  static getNetwork = (netId) => {
    switch ((netId || "").toString()) {
      case "1":
      case "0x1":
        return "ethereum";
      case "2":
      case "0x2":
        return "morden";
      case "3":
      case "0x3":
        return "ropsten";
      case "4":
      case "0x4":
        return "rinkeby";
      case "42":
      case "0x42":
        return "Kovan";
      case "13881":
      case "0x13881":
      case "80001":
      case "0x80001":
        return "Mumbai";
      case "89":
      case "0x89":
      case "137":
        return "polygon";
      case "38":
      case "0x38":
      case "56":
      case "0x56":
        return "bsc";
      case "61":
      case "0x61":
      case "97":
      case "0x97":
        return "bsc testnet";
      default:
        return "Unknown";
    }
  };

  static getMoralisSymbol = (netId) => {
    switch ((netId || "").toString()) {
      case "1":
      case "0x1":
        return "eth";
      case "2":
      case "0x2":
        return "morden";
      case "3":
      case "0x3":
        return "ropsten";
      case "4":
      case "0x4":
        return "rinkeby";
      case "42":
      case "0x42":
        return "Kovan";
      case "13881":
      case "0x13881":
      case "80001":
      case "0x80001":
        return "Mumbai";
      case "89":
      case "0x89":
      case "137":
        return "polygon";
      case "38":
      case "0x38":
      case "56":
      case "0x56":
        return "bsc";
      case "61":
      case "0x61":
      case "97":
      case "0x97":
        return "bsc testnet";
      default:
        return "Unknown";
    }
  };

  static getNetworkText = (network) => {
    switch (network) {
      case "Main":
      case "Rinkeby":
        return "Ethereum (ETH)";

      case "bsc":
      case "bsc testnet":
        return "Binance Smart Chain (BSC)";

      case "polygon":
      case "mumbai":
        return "Polygon";

      default:
        return "";
    }
  };

  static getNetworkExplorer = (network) => {
    switch (network) {
      case "Main":
      case "1":
        return "https://etherscan.io"
      case "Rinkeby":
      case "4":
        return "https://rinkeby.etherscan.io"
      case "bsc":
      case "38":
      case "56":
        return "https://bscscan.com"
      case "bsc testnet":
      case "61":
      case "97":
        return "https://testnet.bscscan.com"
      case "polygon":
      case "137":
        return "https://polygonscan.com/"
      case "mumbai":
      case "13881":
      case "80001":
        return "https://mumbai.polygonscan.com/"
    }
  }

  static getOwnerAddress = async (tokenId, contractAddress, web3) => {
    const contract = new web3.eth.Contract(
      marketplaceContractAbi as AbiItem[],
      contractAddress
    );
    const ownerAddress = await contract?.methods.ownerOf(tokenId).call();
    return ownerAddress;
  };

  static getChainId(protocol) {
    switch (protocol) {
      case Protocols.ethereum.name:
      case Protocols.bsc.name:
      case Protocols.polygon.name:
        return Protocols[protocol].chainId[
          CommonConstant.mode === "PRODUCTION" ? "mainnet" : "testnet"
        ];
      default:
        return null;
    }
  }
}
